import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import AdminTopPage from '../AdminTopPage'
import Init from '../Auth/Init'
import LoginPage from '../LoginPage'

import { routes } from '../../config'
import AdminClientPage from '../AdminClientsPage'
import AdminDevicePage from '../AdminDevicePage'

const App = () => (
  <BrowserRouter>
    <div>
      <Init />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path={routes.menu} element={<AdminTopPage />} />
        <Route path={routes.client} element={<AdminClientPage />} />
        <Route path={routes.device} element={<AdminDevicePage />} />
        <Route path="/*" element={<Navigate to={routes.menu} />} />
      </Routes>
    </div>
  </BrowserRouter>
)

export default App
